export const previewOrganizationDeletion = /* GraphQL */ `
  mutation PreviewOrganizationDeletion($organizationID: String!) {
    previewOrganizationDeletion(organizationID: $organizationID) {
      organizationID
      organizationName
      portalCount
      portals {
        portalID
        portalName
        stackName
        dynamoCounts
        pgvectorRowCount
      }
      dynamoCounts
      pgvectorRowCount
      repositoryBucketCount
      stacksToDestroy
    }
  }
`;

export const deleteOrganizationPermanently = /* GraphQL */ `
  mutation DeleteOrganizationPermanently($organizationID: String!, $confirmationPhrase: String!) {
    deleteOrganizationPermanently(organizationID: $organizationID, confirmationPhrase: $confirmationPhrase) {
      id
      status
      purgeScheduledAt
    }
  }
`;

export const hardDeleteOrganizationNow = /* GraphQL */ `
  mutation HardDeleteOrganizationNow($organizationID: String!, $confirmationPhrase: String!) {
    hardDeleteOrganizationNow(organizationID: $organizationID, confirmationPhrase: $confirmationPhrase) {
      id
      status
      purgeStatus
    }
  }
`;

/** Lightweight poll query: just the fields needed to track a background purge. */
export const getOrganizationPurgeStatus = /* GraphQL */ `
  query GetOrganizationPurgeStatus($id: ID!) {
    getOrganization(id: $id) {
      id
      status
      purgeStatus
      purgeError
    }
  }
`;

export const cancelOrganizationDeletion = /* GraphQL */ `
  mutation CancelOrganizationDeletion($organizationID: String!) {
    cancelOrganizationDeletion(organizationID: $organizationID) {
      id
      status
    }
  }
`;

export const previewPortalDeletion = /* GraphQL */ `
  mutation PreviewPortalDeletion($organizationID: String!, $portalID: String!) {
    previewPortalDeletion(organizationID: $organizationID, portalID: $portalID) {
      portalID
      portalName
      stackName
      dynamoCounts
      pgvectorRowCount
    }
  }
`;

export const deletePortalPermanently = /* GraphQL */ `
  mutation DeletePortalPermanently(
    $organizationID: String!
    $portalID: String!
    $confirmationPhrase: String!
  ) {
    deletePortalPermanently(
      organizationID: $organizationID
      portalID: $portalID
      confirmationPhrase: $confirmationPhrase
    ) {
      id
      organizationID
      status
      purgeStatus
    }
  }
`;
